export default __webpack_public_path__ + "static/media/office1-after1-2048w.b40e050f.webp";